import { useState } from 'react';
import { useDebouncedValue, DEBOUNCE_MS } from '../../../lib/useDebouncedValue';

export interface ServiciosFilters {
  search: string;
  searchDebounced: string;
  estado: number | undefined;
  idPlan: number | undefined;
  idTipoServicio: number | undefined;
  page: number;
  setSearch: (value: string) => void;
  setEstado: (value: number | undefined) => void;
  setIdPlan: (value: number | undefined) => void;
  setIdTipoServicio: (value: number | undefined) => void;
  setPage: (value: number) => void;
  hasFilters: boolean;
}

export function useServiciosFilters(): ServiciosFilters {
  const [search, setSearchRaw] = useState('');
  const [estado, setEstadoRaw] = useState<number | undefined>(undefined);
  const [idPlan, setIdPlanRaw] = useState<number | undefined>(undefined);
  const [idTipoServicio, setIdTipoServicioRaw] = useState<number | undefined>(undefined);
  const [page, setPage] = useState(1);

  // El input actualiza `search` al instante; las queries esperan 350ms sin
  // tipeo para no disparar un request por tecla.
  const searchDebounced = useDebouncedValue(search, DEBOUNCE_MS);

  const setSearch = (value: string) => {
    setSearchRaw(value);
    setPage(1);
  };

  const setEstado = (value: number | undefined) => {
    setEstadoRaw(value);
    setPage(1);
  };

  const setIdPlan = (value: number | undefined) => {
    setIdPlanRaw(value);
    setPage(1);
  };

  const setIdTipoServicio = (value: number | undefined) => {
    setIdTipoServicioRaw(value);
    setPage(1);
  };

  const hasFilters =
    search !== '' || estado !== undefined || idPlan !== undefined || idTipoServicio !== undefined;

  return {
    search,
    searchDebounced,
    estado,
    idPlan,
    idTipoServicio,
    page,
    setSearch,
    setEstado,
    setIdPlan,
    setIdTipoServicio,
    setPage,
    hasFilters,
  };
}
